import { useQuery } from "@tanstack/react-query";

import { Response } from "../types";

import { Model } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useModelConfigsDataList = (userToken: string) =>
  useQuery<Response<Model[], "results", string>>({
    queryKey: ["globalModelConfigs"],
    queryFn: async () => {
      const response = await fetch(ENDPOINTS.global_model_configs, {
        headers: jsonAuthHeaders(userToken),
        method: "GET",
      });
      return handleResponse(response);
    },
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
  });
